// ==============================================================================
// LÓGICA DE TRAVA DE COOKIES + CENTRALIZAÇÃO DPO EASY + MULTI-IDIOMA (PT, EN, ES)
// ==============================================================================

function initCookieLock() {
    // [TEMPORÁRIO - TESTE]
    const hasTagInBody = document.body.className.includes('trava-cookies');
    const hasTagLink   = document.querySelector('a[href*="trava-cookies"]');

    if (!hasTagInBody && !hasTagLink) {
        return;
    }

    // 0. Dicionário de Idiomas e Detecção
    const messages = {
        pt: {
            rejectionNotice: 'Para continuar navegando e acessar o conteúdo completo da página, é necessário aceitar os cookies.',
            adblockTitle: 'Bloqueador de Anúncios Detectado 🛡️',
            adblockText1: 'Identificamos que você está utilizando um AdBlocker ou extensão de privacidade que impediu a exibição do nosso aviso de privacidade e cookies.',
            adblockText2: 'Para visualizar este conteúdo, por gentileza <strong>desative o AdBlocker nesta página</strong> e recarregue o site.',
            adblockBtn: 'Já desativei, recarregar página'
        },
        en: {
            rejectionNotice: 'To continue browsing and access the full page content, you must accept cookies.',
            adblockTitle: 'Ad Blocker Detected 🛡️',
            adblockText1: 'We noticed that you are using an AdBlocker or privacy extension that prevented our privacy and cookie notice from displaying.',
            adblockText2: 'To view this content, please <strong>disable the AdBlocker on this page</strong> and reload the site.',
            adblockBtn: 'I have disabled it, reload page'
        },
        es: {
            rejectionNotice: 'Para continuar navegando y acceder al contenido completo de la página, es necesario aceptar las cookies.',
            adblockTitle: 'Bloqueador de Anuncios Detectado 🛡️',
            adblockText1: 'Identificamos que está utilizando un AdBlocker o extensión de privacidad que impidió la visualización de nuestro aviso de privacidad y cookies.',
            adblockText2: 'Para ver este contenido, por favor <strong>desactive el AdBlocker en esta página</strong> y recargue el sitio.',
            adblockBtn: 'Ya lo desactivé, recargar página'
        }
    };

    function getCurrentLang() {
        const htmlLang = (document.documentElement.lang || '').toLowerCase();
        const path = window.location.pathname.toLowerCase();

        if (htmlLang.startsWith('en') || path.includes('/en/')) return 'en';
        if (htmlLang.startsWith('es') || path.includes('/es/')) return 'es';
        return 'pt'; // Idioma padrão
    }

    const currentLang = getCurrentLang();
    const txt = messages[currentLang];

    // 1. Checagem Ultra-Rápida via Cookie Físico (Evita o Flicker/Piscada no F5)
    const hasConsentCookie = document.cookie.split(';').some(c => {
        const item = c.trim().toLowerCase();
        return item.includes('dpoeasy') || item.includes('cookie_consent') || item.includes('consent=true');
    });

    const isInitiallyGranted = checkDataLayerConsent();

    if (!isInitiallyGranted && !hasConsentCookie) {
        document.body.classList.add('cookie-locked');
    }

    // 2. Injeção de Estilos no DOM Principal
    const style = document.createElement('style');
    style.innerHTML = `
        /* Blur e Trava de Scroll quando não aceito */
        body.cookie-locked {
            overflow: hidden !important;
        }

        body.cookie-locked header,
        body.cookie-locked main,
        body.cookie-locked footer,
        body.cookie-locked #page,
        body.cookie-locked .site-content {
            filter: blur(8px) !important;
            pointer-events: none !important;
            user-select: none !important;
            transition: filter 0.3s ease;
        }

        /* Container do Banner */
        #dpoeasy-banner {
            filter: none !important;
            pointer-events: auto !important;
            user-select: auto !important;
            z-index: 99999999 !important;
        }

        /* Fundo escurecido no backdrop APENAS enquanto o site estiver travado */
        body.cookie-locked #dpoeasy-banner {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            background: rgba(0, 0, 0, 0.4) !important;
        }

        /* MENSAGEM DE AVISO EXTERNA (Desktop) */
        #dpoeasy-rejection-notice {
            display: none;
            position: fixed;
            top: calc(88%);
            left: 50%;
            transform: translateX(-50%);
            z-index: 999999999;
            background-color: #fff3cd;
            border: 1px solid #ffeeba;
            color: #856404;
            padding: 12px 24px;
            border-radius: 12px;
            font-size: 13.5px;
            font-weight: bold;
            font-family: Arial, sans-serif;
            text-align: center;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
            max-width: 680px;
            width: 90%;
            box-sizing: border-box;
            opacity: 0;
            transition: opacity 0.3s ease, transform 0.3s ease;
        }

        body.cookie-locked #dpoeasy-rejection-notice.is-visible {
            display: block !important;
            opacity: 1;
            transform: translate(-50%, 0);
        }

        /* AJUSTE PARA MOBILE (Telas menores que 768px) */
        @media (max-width: 767px) {
            #dpoeasy-rejection-notice {
                top: 86% !important;
            }
        }

        /* Estilos do Modal do Aviso de AdBlock */
        #adblock-warning-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999999999;
            padding: 20px;
            box-sizing: border-box;
        }

        #adblock-warning-modal .adblock-card {
            background: #ffffff;
            padding: 32px;
            border-radius: 20px;
            max-width: 480px;
            width: 100%;
            text-align: center;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            font-family: Arial, sans-serif;
        }

        #adblock-warning-modal h3 {
            font-size: 20px;
            font-weight: bold;
            color: #2C5372;
            margin: 0 0 12px 0;
        }

        #adblock-warning-modal p {
            font-size: 14px;
            line-height: 1.5;
            color: #4a5568;
            margin: 0 0 20px 0;
        }

        #adblock-warning-modal button {
            background: #2C5372;
            color: #ffffff;
            border: none;
            padding: 12px 24px;
            border-radius: 10px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            transition: background 0.2s ease;
        }

        #adblock-warning-modal button:hover {
            background: #1e3a50;
        }
    `;
    document.head.appendChild(style);

    // Injeta a div da mensagem de aviso diretamente no <body>
    function createExternalNotice() {
        if (!document.getElementById('dpoeasy-rejection-notice')) {
            const notice = document.createElement('div');
            notice.id = 'dpoeasy-rejection-notice';
            notice.innerHTML = txt.rejectionNotice;
            document.body.appendChild(notice);
        }
    }

    // 3. Auxiliar para ler o dataLayer
    function checkDataLayerConsent() {
        if (!window.dataLayer) return false;

        const consentEntry = window.dataLayer
            .slice()
            .reverse()
            .find(entry =>
                entry &&
                (entry[0] === 'consent' || entry.event === 'cookie_consent_update')
            );

        if (consentEntry) {
            const consentData = consentEntry[2] || consentEntry;
            return consentData.analytics_storage === 'granted' || consentData.ad_storage === 'granted';
        }

        return false;
    }

    // 4. CSS e Eventos Injetados no Shadow DOM
    function styleShadowDOM() {
        const bannerHost = document.getElementById('dpoeasy-banner');

        if (bannerHost && bannerHost.shadowRoot) {
            const shadow = bannerHost.shadowRoot;

            if (!shadow.querySelector('#custom-shadow-style')) {
                const shadowStyle = document.createElement('style');
                shadowStyle.id = 'custom-shadow-style';
                shadowStyle.innerHTML = `
                    .dpoeasy-hidden,
                    [hidden] {
                        display: none !important;
                    }

                    .dpoeasy-root {
                        transition: opacity 0.3s ease-in-out !important;
                    }

                    .dpoeasy-root:not(.dpoeasy-hidden) {
                        position: fixed !important;
                        top: 0 !important;
                        left: 0 !important;
                        width: 100vw !important;
                        height: 100vh !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        box-sizing: border-box !important;
                        padding: 20px !important;
                        z-index: 99999999 !important;
                        pointer-events: auto !important;
                        opacity: 1 !important;
                    }

                    .dpoeasy-shell,
                    .dpoeasy-banner-content {
                        position: static !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        width: 100% !important;
                        max-width: 720px !important;
                        margin: auto !important;
                    }

                    .dpoeasy-card {
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
                        border-radius: 20px !important;
                        width: 100% !important;
                        max-height: none !important;
                    }

                    .dpoeasy-description {
                        max-height: none !important;
                        -webkit-line-clamp: unset !important;
                        display: block !important;
                    }

                    .dpoeasy-show-more {
                        display: none !important;
                    }

                    .dpoeasy-handler {
                        position: fixed !important;
                        z-index: 999999 !important;
                    }
                `;
                shadow.appendChild(shadowStyle);
            }

            ensureBannerVisibilityIfLocked(shadow);

            // Escuta o clique em REJEITAR
            const rejectBtn = shadow.querySelector('[data-action="reject"]');
            if (rejectBtn && !rejectBtn.dataset.hasRejectListener) {
                rejectBtn.dataset.hasRejectListener = "true";
                rejectBtn.addEventListener('click', () => {
                    document.body.classList.add('cookie-locked');

                    const noticeEl = document.getElementById('dpoeasy-rejection-notice');
                    if (noticeEl) {
                        noticeEl.classList.remove('is-visible');
                    }

                    setTimeout(() => {
                        const handlerBtn = shadow.querySelector('.dpoeasy-handler');
                        if (handlerBtn) {
                            handlerBtn.click();
                        }
                        if (noticeEl) {
                            noticeEl.classList.add('is-visible');
                        }
                    }, 400);
                });
            }

            // Oculta a mensagem se o usuário clicar em ACEITAR
            const acceptBtn = shadow.querySelector('[data-action="accept"]');
            if (acceptBtn && !acceptBtn.dataset.hasAcceptListener) {
                acceptBtn.dataset.hasAcceptListener = "true";
                acceptBtn.addEventListener('click', () => {
                    const noticeEl = document.getElementById('dpoeasy-rejection-notice');
                    if (noticeEl) {
                        noticeEl.classList.remove('is-visible');
                    }
                });
            }
        }
    }

    // Força a reabertura do modal se a página estiver travada
    function ensureBannerVisibilityIfLocked(shadow) {
        if (!document.body.classList.contains('cookie-locked')) {
            return;
        }

        const rootEl = shadow.querySelector('.dpoeasy-root');
        const handlerBtn = shadow.querySelector('.dpoeasy-handler');

        if (rootEl && rootEl.classList.contains('dpoeasy-hidden') && handlerBtn) {
            handlerBtn.click();
        }
    }

    // 5. Aviso de AdBlock
    function showAdBlockWarning() {
        if (document.getElementById('adblock-warning-modal')) {
            return;
        }

        const modal = document.createElement('div');
        modal.id = 'adblock-warning-modal';
        modal.innerHTML = `
            <div class="adblock-card">
                <h3>${txt.adblockTitle}</h3>
                <p>${txt.adblockText1}</p>
                <p>${txt.adblockText2}</p>
                <button onclick="window.location.reload()">${txt.adblockBtn}</button>
            </div>
        `;

        document.body.appendChild(modal);
    }

    function checkAdBlock() {
        setTimeout(() => {
            const bannerHost = document.getElementById('dpoeasy-banner');
            const isShadowDOMInjected = bannerHost &&
                bannerHost.shadowRoot &&
                bannerHost.shadowRoot.querySelector('.dpoeasy-card');

            if (document.body.classList.contains('cookie-locked') && !isShadowDOMInjected) {
                showAdBlockWarning();
            }
        }, 1000);
    }

    // 6. Atualizador de Status
    function checkConsentStatus() {
        const isGranted = checkDataLayerConsent();

        if (isGranted) {
            document.body.classList.remove('cookie-locked');

            const modal = document.getElementById('adblock-warning-modal');
            if (modal) {
                modal.remove();
            }

            const noticeEl = document.getElementById('dpoeasy-rejection-notice');
            if (noticeEl) {
                noticeEl.classList.remove('is-visible');
            }
        } else {
            const consentEntry = window.dataLayer && window.dataLayer.slice().reverse().find(e => e && (e[0] === 'consent' || e.event === 'cookie_consent_update'));
            if (consentEntry) {
                document.body.classList.add('cookie-locked');
            }
        }

        styleShadowDOM();
    }

    // Monitora a injeção do elemento no DOM
    const observer = new MutationObserver(() => {
        if (document.getElementById('dpoeasy-banner')) {
            styleShadowDOM();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Interceptador do dataLayer
    (function() {
        window.dataLayer = window.dataLayer || [];
        const originalPush = window.dataLayer.push;

        window.dataLayer.push = function() {
            const result = originalPush.apply(this, arguments);
            checkConsentStatus();
            return result;
        };
    })();

    createExternalNotice();
    checkConsentStatus();
    checkAdBlock();
}

document.addEventListener('DOMContentLoaded', initCookieLock);
